import { TextField } from "@fluentui/react";
import React from "react";
import { IQuestionControlProps } from "shared/containers";

export const DateControl: React.FC<IQuestionControlProps> = (props) => {
	const {
		parentId,
		disabled,
		formId,
		fieldId,
		label,
		value,
		valueId,
		fieldAttribute,
		fieldType,
		errorMessage,
		onChange,
	} = props;

	const onValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (onChange)
			onChange(
				parentId,
				fieldId,
				formId,
				fieldAttribute,
				fieldType,
				event.target.value,
				valueId
			);
	};
	return (
		<div className="form-group">
			{label && <label>{label}</label>}
			<input
				type="date"
				className="form-control"
				value={value}
				disabled={disabled}
				onChange={(e) => onValueChange(e)}
			/>
		</div>
	);
	// return (
	// 	<TextField
	// 		type="date"
	// 		disabled={disabled}
	// 		label={label}
	// 		value={value}
	// 		errorMessage={errorMessage}
	// 		onChange={onValueChange}
	// 	/>
	// );
};
